import {app} from '../main'
import * as types from './mutation-types'


export const state = {
  lang: 'en'
}

export const mutations = {
  [types.SET_LANG] (state, payload) {


    /*console.log('antigo lang: ', app.$i18n.locale) //en*/

    localStorage.setItem('lang', payload)
    let lang = localStorage.getItem('lang')

    app.$i18n.locale = lang
/*    console.log('novo lang: ', lang) //pt*/

	if(lang == 'pt'){
    	alert('Idioma salvo com sucesso!')
	}else{
    	alert('Language saved successfully!')
	}



    app.$router.push('/')

    //REFRESH GERAL
    location.reload()
  }
}

export const actions = {
  setLang ({commit}, payload) {

    commit(types.SET_LANG, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js